module.exports = __webpack_public_path__ + "static/media/logo-gs.d234bbe1.jpg";